module.exports = __webpack_public_path__ + "static/img/sdl_logo@3x.97e1b7b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/3x/sdl_logo@3x.png
// module id = C1un
// module chunks = 1